import { createSlice } from '@reduxjs/toolkit';
import { ApplicationState } from './state';
import reducers from './reducers';

const initialState: ApplicationState = {
  selected_branches: [],
  selected_service: [],
};

const application = createSlice({
  name: 'application',
  initialState,
  reducers,
});

export const applicationActions = { ...application.actions };
export default application;
